import PropTypes from 'prop-types';
import { colors } from 'components/styles/variables';

const Category = ({ category }) => {
  if (!category) {
    return null;
  }

  return (
    <ul className="category-container">
      <li className="category" key={category.name}>
        {category.name}
      </li>
      <style jsx>{`
        .category-container {
          padding-left: 0;
          margin-top: 10px;
          float: left;
        }

        .category {
          list-style: none;
          display: inline-block;
          padding: 2px 12px 2px 12px;
          color: white;
          font-size: 14px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.2px;
          width: fit-content;
          border: solid 1px ${colors.ALR1};
          background-color: ${colors.ALR1};
        }

        .category + .category::before {
          content: ' | ';
          color: ${colors.G2};
          font-weight: normal;
          position: relative;
          display: inline-block;
          margin-right: 5px;
        }
      `}</style>
    </ul>
  );
};

Category.propTypes = {
  category: PropTypes.object,
};

export default Category;
